function MobileNavUnauthed() {
  return (
    <>
      <a
        href="https://retainerclub.com"
        className="-mx-3 block rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-7 hover:bg-gray-50"
      >
        Home
      </a>
      <a
        href="https://locator.retainerclub.com"
        className="-mx-3 block rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-7 hover:bg-gray-50"
      >
        Get Started
      </a>
      <a
        href="https://retainerclub.com/why-replace-retainers"
        className="-mx-3 block rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-7 hover:bg-gray-50"
      >
        Why Replace Retainers?
      </a>
      <a
        href="https://retainerclub.com/support"
        className="-mx-3 block rounded-lg px-3 py-2 font-semibold text-base text-gray-900 leading-7 hover:bg-gray-50"
      >
        Support
      </a>
    </>
  );
}

export default MobileNavUnauthed;
